import { Inject, Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, map } from 'rxjs';
import { EMR_API, IFile } from '@appgen-health-crm/api-interfaces';

@Pipe({
  standalone: true,
  name: 'file'
})
export class FilePipe implements PipeTransform {
  constructor(
    @Inject('apiEndpoint') private apiEndpoint: string,
    private httpClient: HttpClient
  ) {}

  transform(path: any, ...args: unknown[]) {
    const [awsBaseUrl, org, customerId, fileName] = path
      .replace('https://', '')
      .split('/');
    return firstValueFrom(
      this.httpClient
        .get<IFile>(
          `${this.apiEndpoint}${EMR_API.customers.base}/${customerId}/files/${fileName}?url=true`
        )
        .pipe(map(res => res.buffer))
    );
  }
}
